import { render, staticRenderFns } from "./ExportVenueRecommendations.vue?vue&type=template&id=c81213ae&"
import script from "./ExportVenueRecommendations.vue?vue&type=script&lang=js&"
export * from "./ExportVenueRecommendations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports